import { NavLink, useLocation, Link } from 'react-router-dom';
import { useContext } from 'react';
import { Tooltip } from 'react-tooltip';

import { projectContext, spaceRemover, useTranslate } from '../lib'
import ArrowLeft from '../images/arrow-left-blue.svg';

import '../styles/sideBar.scss'

export default function SideBar(props) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  let location = useLocation()
  let navigationLinks;
  const { t } = useTranslate();

  if(props.project != undefined && !props.project){
    navigationLinks = [
      // {name: "Home", route: "/"},
      // {name: "Report", route: `/${spaceRemover(selectedProject.name)}/Report`},
      {name: "Clients", displayName: t('common.users'), route: `/${spaceRemover(selectedProject.name)}/Users`, active: props.active},
      {name: "Settings", displayName: t('common.settings'), route: `/${spaceRemover(selectedProject.name)}/Settings`, active: props.active},
      {name: "Logs", displayName: t('common.logs'), route: `/${spaceRemover(selectedProject.name)}/changes-logs`, active: props.active},
    ]
  }else{
    navigationLinks = [
      // {name: "Home", route: "/"},
      {name: "Project", displayName: t('common.project'), route: `/${spaceRemover(selectedProject.name)}`, active: props.active},
      {name: "Intents", displayName: t('intents.intents'), route: `/${spaceRemover(selectedProject.name)}/Intents`,  active: props.active},
      {name: "Answers", displayName: t('answers.answers'), route: `/${spaceRemover(selectedProject.name)}/Answers`, active: props.active},
      {name: "Users", displayName: t('common.users'), route: `/${spaceRemover(selectedProject.name)}/Users`, active: props.active},
      {name: "Settings", displayName: t('common.settings'), route: `/${spaceRemover(selectedProject.name)}/Settings`, active: props.active},
      {name: "Logs", displayName: t('common.logs'), route: `/${spaceRemover(selectedProject.name)}/changes-logs`, active: props.active},
    ]
  }

  return (


        <aside style={{height: 'fit-content', marginTop: "9%"}}>
          <Link to={'/projects'} style={{marginTop: -60}} className='link_back_projects'>
            <img src={ArrowLeft} className='img_back_projects'></img>
            <p style={{color: 'gray', fontSize: 12}}>{t('menu.listOfProjects')}</p>
          </Link>
      {/* <div className='icon bg-[#ffffff00]' style={{backgroundColor: "#ffffff00"}}></div> */}
      {navigationLinks.map(({name, displayName, route, active}, index) => {
        let title_tooltip = '';

        switch(name){
          case 'Project': 
            title_tooltip = t('menu.projectDetails');
            break;
          case 'Intents': 
            title_tooltip = t('menu.projectIntents');
            break;
          case 'Answers': 
            title_tooltip = t('menu.projectAnswers');
            break;
          case 'Users': 
            title_tooltip = t('menu.projectUsers');
            break;  
          case 'Settings': 
            title_tooltip = t('menu.projectSettings');
            break;
          case 'Logs': 
            title_tooltip = t('menu.projectChangesLog');
            break;
        }

        return (
          <NavLink id={`link-${name}`} to={route} key={index} className={ active === name ? "active" : "none"}>
            <img
              src={`/icons/${name}.png`}
              alt={name}
              // style={{minWidth: 10, width: 22}}
            />
            <Tooltip style={{fontSize: 13, maxWidth: 160}}
                anchorId={`link-${name}`} content={title_tooltip} place="top" />
            <p>{displayName}</p>
          </NavLink>
        )
      })}
    </aside>
  )
}
